export const colors = {
    primary: '#00587c',      // Primary color (plcolor1) - from "Parking"
    secondary: '#f26b1d',    // Secondary color (plcolor2) - from "P" and "Lap"
    background: '#f9f9f9',   // Background color
    textPrimary: '#333',     // Primary text color
    textSecondary: '#666',   // Secondary text color
};
export const themeConfig = {
    token: {
        colorPrimary: colors.primary,      // Use primary color variable
        colorLink: colors.primary,         // Link color (same as primary color)
        colorBgContainer: colors.background,  // Background color for containers
        colorText: colors.textPrimary,     // Default text color
        colorTextSecondary: colors.textSecondary,  // Secondary text color
        colorSelectedItem: colors.primary, // Selected menu item color
    }, 
    components: {
      Button: {
        colorPrimary: '#00587c',
      },
      Menu: {
        itemSelectedBg: '#e6f7ff',
        itemHoverBg: '#f0f5ff',
        colorItemTextHover: '#00587c',
        colorItemTextSelected: '#00587c',
      },
      Dropdown: {
        colorBgElevated: '#ffffff',
      },
    },
};  
 